import { WhitelabelConfig } from './WhitelabelConfig'
import { lydian } from './lydian'
import { valutaMarkets } from './valutaMarkets'
import { tauroMarkets } from './tauroMarkets'
import { skyGround } from './skyground'
import { tauroMarketsItaly } from './tauroMarketsItaly'

function getConfigForWhiteLabel(domainName: string): WhitelabelConfig {
  const allConfigs = [lydian, skyGround, tauroMarkets, tauroMarketsItaly, valutaMarkets]
  const config = allConfigs.find(x => {
    for (const targetDomainName of x.domainNames) {
      if (domainName.includes(targetDomainName)) {
        return true
      }
    }
    return false
  })
  if (!config) {
    throw new Error('Cannot find the config')
  }
  return config
}

export const whitelabelConfig = getConfigForWhiteLabel(window.location.hostname)
